import { useState, useEffect } from "react";
import "./blogs.css";
// import { BlogsDataTable } from "views/admin/default/variables/columnsData";
// import tableDataComplex from "../default/variables/tableDataComplex.json";
// import ComplexTable from "views/admin/default/components/ComplexTable";
import { getAllBlog } from "proxyUrl";
// import { GetBookingDataByUserId } from "proxyUrl";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import axios from "axios";
import BlogTable from "./BlogTable";
const Blogs = () => {
  const [blogData, setBlogData] = useState("");
  const [titleSearch, setTitleSearch] = useState("");
  const [blogTypeFilter, setBlogTypeFilter] = useState("");
  const [loading, setLoading] = useState(false);

  // console.log(user)
  const currentUser = useSelector((state) => state.user.user.userRole.name);
  console.log(currentUser);
  
  const fetchData = () => {
    setLoading(true);
    
    // Build query parameters
    const params = {};
    if (titleSearch && titleSearch.trim()) {
      // Trim and normalize spaces (replace multiple spaces with single space)
      const normalizedTitle = titleSearch.trim().replace(/\s+/g, ' ');
      params.title = normalizedTitle;
    }
    if (blogTypeFilter) {
      params.type = blogTypeFilter;
    }

    // Build query string with percentage encoding
    const queryString = Object.keys(params)
      .map((key) => {
        const value = params[key];
        return `${encodeURIComponent(key)}=${encodeURIComponent(value)}`;
      })
      .join('&');
    
    const url = queryString ? `${getAllBlog}?${queryString}` : getAllBlog;

    axios
      .get(url, {
        withCredentials: true,
      })
      .then((res) => {
        const blogData = res.data.data || res.data;
        setBlogData(blogData);
        setLoading(false);
      })
      .catch((err) => {
        console.error("Error fetching blogs:", err);
        setLoading(false);
      });
  };

  // Fetch data on component mount
  useEffect(() => {
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Refetch data when filters change (with debounce for title search)
  useEffect(() => {
    const timeoutId = setTimeout(() => {
      fetchData();
    }, titleSearch ? 500 : 0); // Debounce title search by 500ms

    return () => clearTimeout(timeoutId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [titleSearch, blogTypeFilter]);

  // console.log(user.length);
  return (
    <>
      <div className=" add-booking-header  relative  mx-4 mt-6 flex justify-between rounded-2xl bg-primaryBlue p-3 shadow-lg dark:bg-navy-800">
        <div className="text-xl font-bold text-white  dark:text-white">
          All Blog
        </div>
        <Link to="/admin/blogs/add">
          <button className="rounded-full bg-white p-1  px-3 text-navy-800 dark:bg-navy-900 dark:text-white">
            Add Blog
          </button>
        </Link>
      </div>
      
      {/* Filter Section */}
      <div className="mx-4 mt-4 rounded-2xl bg-white p-4 shadow-lg dark:bg-navy-800">
        <div className="grid grid-cols-1 gap-4 md:grid-cols-12">
          {/* Title Search Input - col-6 */}
          <div className="md:col-span-6">
            <label
              htmlFor="title-search"
              className="mb-2 block text-sm font-medium text-navy-900 dark:text-white"
            >
              Search by Title
            </label>
            <input
              type="text"
              id="title-search"
              placeholder="Search blog title..."
              value={titleSearch}
              onChange={(e) => setTitleSearch(e.target.value)}
              className="w-full rounded-lg border border-gray-300 bg-white px-4 py-2 text-sm text-navy-900 placeholder-gray-400 focus:border-primaryBlue focus:outline-none dark:border-gray-600 dark:bg-navy-700 dark:text-white"
            />
          </div>

          {/* Blog Type Select - col-6 */}
          <div className="md:col-span-6">
            <label
              htmlFor="blog-type-filter"
              className="mb-2 block text-sm font-medium text-navy-900 dark:text-white"
            >
              Filter by Type
            </label>
            <select
              id="blog-type-filter"
              value={blogTypeFilter}
              onChange={(e) => setBlogTypeFilter(e.target.value)}
              className="w-full rounded-lg border border-gray-300 bg-white px-4 py-2 text-sm text-navy-900 focus:border-primaryBlue focus:outline-none dark:border-gray-600 dark:bg-navy-700 dark:text-white"
            >
              <option value="">All Types</option>
              <option value="1">Fliotravels</option>
              <option value="2">Aoneff</option>
              <option value="3">Parents Arena</option>
            </select>
          </div>
        </div>
      </div>

      <div className="relative   grid w-full grid-cols-1 gap-5 md:grid-cols-1">
        {/* <TotalSpent /> */}
        {/* <WeeklyRevenue /> */}
        {loading ? (
          <div className="flex items-center justify-center p-8">
            <div className="text-lg text-navy-900 dark:text-white">Loading...</div>
          </div>
        ) : blogData ? (
          // <ComplexTable
          //   columnsData={BlogsDataTable}
          //   columnLenghth={blogData.length}
          //   tableData={blogData}
          //   editRoute={`/admin/blogs/edit`}
          //   deleteRoute={`/admin/blogs/delete`}
          // />
          <>
            <BlogTable
              columnLenghth={blogData.length}
              tableData={blogData}
              editRoute={`/admin/blogs/edit`}
              deleteRoute={`/admin/blogs/delete`}
            />
          </>
        ) : (
          <></>
        )}
      </div>
    </>
  );
};

export default Blogs;
